import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "draggable"]
const _hoisted_2 = ["name"]

export interface propsComponent {
  isPreview: boolean;
}
import { useAttrs, computed, withDefaults } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "VZInput",
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    isPreview: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { isPreview: boolean }


const attrs = useAttrs();
const style = computed(() => {
  return !props.isPreview ? "pointer-events: none" : "";
});
const restAttr = computed(() => {
  const { id, draggable, ...rest } = attrs;
  if (rest.style && rest.style.defaultBorder === "true !important") {
    rest.style.borderColor = "";
    rest.style.borderWidth = "";
    rest.style.borderStyle = "";
    rest.style.padding = "";
    rest.style.margin = "";
    rest.borderColor = "";
    rest.borderWidth = "";
    rest.borderStyle = "";
    rest.padding = "";
    rest.margin = "";
  }

  return rest;
});
const isDraggable = computed(() => {
  return attrs?.draggable ?? false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "VZ_TABLE_INPUT",
    id: _unref(attrs).id,
    draggable: _unref(isDraggable)
  }, [
    _createElementVNode("input", _mergeProps({ type: "text" }, _unref(restAttr), {
      name: _unref(attrs).name,
      style: _unref(style),
      defaultValue: ''
    }), null, 16, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})